import { store } from '@/store/store'
import Layout from '@/container/Full'

const DomainList = () => import(/* webpackChunkName: "domains" */ './../views/domains/DomainsListView')
const DomainSingle = () => import(/* webpackChunkName: "domains" */ './../views/domains/DomainSingleView')
const DomainInfo = () => import(/* webpackChunkName: "domains" */ './../views/domains/DomainInfoView')
const DomainWhois = () => import(/* webpackChunkName: "domains" */ './../views/domains/DomainWhoisView')
const DomainNameservers = () => import(/* webpackChunkName: "domains" */ './../views/domains/DomainNameserversView')
const DomainRegistrationRequest = () => import(/* webpackChunkName: "domains" */ './../views/domains/DomainRegistrationView')
const DomainTransferRequest = () => import(/* webpackChunkName: "domains" */ './../views/domains/DomainTransferView')
const DomainTransferRequestView = () => import(/* webpackChunkName: "domains" */ './../views/domains/DomainTransferRequestView')

const routes = [
  {
    path: '/domains',
    component: Layout,
    params: true,
    meta: {
      breadcrumb: 'My Domains',
      pageTitle: 'My Domains',
      access_type: 'authorized'
    },
    children: [
      {
        path: '',
        name: 'domains',
        component: DomainList,
        meta: {
          access_type: 'authorized',
          pageTitle: 'My Domains',
        }
      },
      {
        path: '/domains/:domainid',
        component: DomainSingle,
        props: true,
        meta: {
          breadcrumb: () => store.getters.domain.domain,
          pageTitle: 'My Domains',
          access_type: 'authorized'
        },
        children: [
          {
            path: '',
            component: DomainInfo,
            name: 'domain_info',
            props: true,
            meta: {
              breadcrumb: 'Domain info',
              pageTitle: 'My Domains',
              access_type: 'authorized'
            },
          },
          {
            path: 'whois',
            name: 'domain_whois',
            component: DomainWhois,
            props: true,
            meta: {
              breadcrumb: 'Domain WHOIS',
              pageTitle: 'My Domains',
              access_type: 'authorized'
            },
          },
          {
            path: 'nameservers',
            name: 'domain_nameservers',
            component: DomainNameservers,
            props: true,
            meta: {
              breadcrumb: 'Nameservers',
              pageTitle: 'My Domains',
              access_type: 'authorized'
            }
          },
        ]
      },
      {
        path: '/domain-registration',
        name: 'domain_registration',
        component: DomainRegistrationRequest,
        meta: {
          breadcrumb: 'Domain registration request',
          pageTitle: 'Register a Domain',
          access_type: 'authorized'
        }
      },
      {
        path: '/domain-transfer',
        name: 'domain_transfer',
        component: DomainTransferRequest,
        meta: {
          breadcrumb: 'Domain transfer request',
          pageTitle: 'Transfer a Domain',
          access_type: 'authorized'
        }
      },
      {
        path: '/domaintransfer/:domainTransferId',
        name: 'domaintransfer_view',
        component: DomainTransferRequestView,
        meta: {
          breadcrumb: 'View Domain Transfer Request',
          pageTitle: 'View Domain Transfer Request',
          access_type: 'authorized'
        }
      },
    ]
  }
]

export default routes
